// extracted by mini-css-extract-plugin
module.exports = {"noteInput":"UnassignEditorsForm_noteInput_3vSQD","spinAround":"UnassignEditorsForm_spinAround_vk_hd"};